import { c as _c } from "react/compiler-runtime";
import { CustomError } from '@core/utils';
import { useQuery } from '@tanstack/react-query';
import { UnauthQueryOptions } from '@/api';
import { buildRegionMetaData } from '@/utils/buildRegionMetaData';
export type { RegionMetaData, WelloPolicyCode } from '@/utils/buildRegionMetaData';
export const useRegionMetaData = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      ...UnauthQueryOptions["get:/wello/v2/allows/wello-policy-code/all"](),
      staleTime: Infinity,
      gcTime: Infinity,
      select: _temp
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return useQuery(t0);
};
function _temp(t0) {
  const {
    context
  } = t0;
  const {
    contents
  } = context ?? {};
  if (!contents) {
    throw new CustomError({
      return_message: "\uC815\uBCF4\uAC00 \uC5C6\uC2B5\uB2C8\uB2E4."
    });
  }
  return buildRegionMetaData(contents);
}